import axios from "../../axiosConfig";
import { put, call } from "redux-saga/effects";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  GET_FOOTER_PAGE_FAILED,
  GET_FOOTER_PAGE_MOBILESIDE_FAILED,
  GET_FOOTER_PAGE_MOBILESIDE_SUCCESS,
  GET_FOOTER_PAGE_SUCCESS,
  UPDATE_FOOTER_PAGE_FAILED,
  UPDATE_FOOTER_PAGE_SUCCESS,
  FAQ_CREATE_FAILED,
  FAQ_CREATE_SUCCESS,
  FAQ_REMOVE_FAILED,
  FAQ_REMOVE_SUCCESS,
} from "../Actions/FooterPageAction";
import decryptResponse from "../../Components/Decrypt";

export function* updateFooterPageSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/update-footer-by-Id`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: UPDATE_FOOTER_PAGE_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: UPDATE_FOOTER_PAGE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* createFAQPageActionSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/create-faq-data`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: FAQ_CREATE_SUCCESS, payload: data });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: FAQ_CREATE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* RemoveFAQSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `/delete-faq-by-id/${action.payload.id}`,
      action?.payload
    );
    const { success, data, message, errors } = response?.data;
    yield put({ type: FAQ_REMOVE_SUCCESS, payload: action.payload.id });
    yield put({
      type: TOAST_SHOW,
      payload: { message: message, severity: "success" },
    });
  } catch (e) {
    yield put({ type: FAQ_REMOVE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getFooterPageSaga(action) {
  try {
    const response = yield call(axios.get, `/get-footerList`);
    const tab = action.payload;
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_FOOTER_PAGE_SUCCESS, payload: { decryptData, tab } });
  } catch (e) {
    yield put({ type: GET_FOOTER_PAGE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}

export function* getFooterPageMobileSideSaga(action) {
  try {
    const response = yield call(axios.get, `/get-footer`, action?.payload);
    const { success, data, message, errors } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_FOOTER_PAGE_MOBILESIDE_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_FOOTER_PAGE_MOBILESIDE_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
